if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          // Add succeeded: refresh and open the drawer immediately with fresh cart data.
          // No timers here - the /cart/add request has already completed, so /cart.js
          // is guaranteed to include the new item even on slow networks.
          window.refreshCartDrawerFallback(0);
        })
        .catch((e) => {
          console.error(e);
          window.refreshCartDrawerFallback();
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

 window.refreshCartDrawerFallback = function(delay) {
        // delay 0 = add already confirmed; default 800ms only for error/retry paths
        setTimeout(() => {
          fetch("/cart.js", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          })
            .then((response) => response.json())
            .then((cartData) => {
              // Update cart count
              const cartCountElements = document.querySelectorAll(".cart-count-bubble span, .cart-count, [data-cart-count]");
              cartCountElements.forEach((el) => {
                if (el) el.textContent = cartData.item_count;
              });

              // Show cart drawer if it exists
              const cartDrawer = document.querySelector(".new_cart_drawer");
              if (cartDrawer) {
                cartDrawer.classList.add("is-active", "is-visible");
                document.documentElement.style.overflow = "hidden";
              }

              // Trigger cart drawer refresh if functions exist
              if (typeof updatelineitem === "function") {
                document.querySelectorAll(".drawer_item").forEach((item) => item.remove());
                updatelineitem(cartData);
              }
              if (typeof updatedrawer === "function") {
                updatedrawer(cartData);
              }
              if (typeof cartcheck === "function") {
                cartcheck(cartData);
              }

              console.log("Cart drawer refreshed successfully");
            })
            .catch((error) => {
              console.error("Fallback cart refresh failed:", error);
            });
        }, typeof delay === 'number' ? delay : 800);
      }